export default[
  {value: '01', text: '协议转换装置'},
  {value: '02', text: '传感器'},
  {value: '03', text: '智能音视频交互装置'},
  {value: '04', text: '视频采集装置'},
]